import React, { useState, useMemo, useEffect } from "react";
import { Modal, Button, Form, Accordion } from "react-bootstrap";
import "./OpalForAcknowledementModal.css";
import TauriImage from "../../../../TauriImage/TauriImage";
import appURL from '../../../../../appURL.json';
import TauriLoader2 from "../../../../TauriLoader2/TauriLoader2";
import { addRecord, getAll, getNextId, updateRecord } from "../../../../../localDB";
import { transformForAcknowledgementData } from "../../../CoverageFactoryData/CoverageFactoryData";
import OpalAlertModal from "../../../../OpalAlertModal/OpalAlertModal";

const OpalForAcknowledementModal = ({ show, onHide }) => {
  const [loading, setIsLoading] = useState(false);
  const [alertLoading, setAlertLoading] = useState(false);
  const [data, setData] = useState([]);
  const [showMessage, setShowMessage] = useState(false);
  const [alertMessage, setAlertMessage] = useState(null);

  useEffect(() => {
    fetchOnlineData();
  }, [show])



  const fetchOnlineData = async () => {
    try {
      setIsLoading(true);
      const isOnline = JSON.parse(localStorage.getItem("isOnline"));
      const hasInternet = navigator.onLine;

      if (isOnline && hasInternet) {
        const token = localStorage.getItem("token");
        const devId = localStorage.getItem("devId");

        const items = await getAll("item");

        const response = await fetch(`${appURL.API_Acknowledgement}/pending`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            "X-ETR-Device-ID": devId
          },
        });

        if (!response.ok) {
          return;
        }

        const itemMap = Object.fromEntries(
          (items || []).map(i => [i.ID, i])
        );

        const res = await response.json();
        const stocks = await transformForAcknowledgementData(res?.stocks || []);

        const joined = (stocks).map(t => ({
          ...t,
          Items: (t.Items || []).map(i => ({
            ...i,
            Item: itemMap[i.ItemID] || {}
          }))
        }));

        setData(joined);
      }
    } catch (error) {
      return;
    } finally {
      setIsLoading(false);
    }
  }

  const UpdateStocks = async (transactionId) => {
    try {
      const transaction = data.find(t => t.ID === transactionId);
      if (!transaction) return;

      const stockAllocations = await getAll("StockAllocations");

      for (const item of (transaction.Items || [])) {

        const existing = stockAllocations.find(sa =>
          sa.ItemID === item.ItemID &&
          sa.UnitID === item.UnitID &&
          sa.Type === item.Type
        );

        if (existing) {
          await updateRecord("StockAllocations", {
            ...existing,
            Stock: Number(existing.Stock || 0) + Number(item.Stocks || 0)
          });
        } else {
          const nextID = await getNextId("StockAllocations");
          await addRecord("StockAllocations", {
            ID: nextID,
            ItemID: item.ItemID,
            UnitID: item.UnitID,
            Type: item.Type,
            Stock: Number(item.Stocks || 0)
          });
        }
      }
    } catch (error) {
      console.error("UpdateStocks error:", error);
      return;
    }
  };

  const AcknowledgeStocks = async (id) => {
    try {
      setAlertLoading(true);

      const token = localStorage.getItem("token");
      const devId = localStorage.getItem("devId");

      const response = await fetch(`${appURL.API_Acknowledgement}/${id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
          "X-ETR-Device-ID": devId
        },
      });

      if (!response.ok) {
        setAlertMessage({
          title: "Message",
          bodyText: "Acknowledged Failed!",
          onConfirm: () => setShowMessage(false),
          confirmText: "OK"
        });
        setShowMessage(true);
        return;
      }

      await UpdateStocks(id);
      await fetchOnlineData();

      setShowMessage(false);
      window.dispatchEvent(new Event("refreshAcknowledgement"));
    } catch (error) {
      setAlertMessage({
        title: "Message",
        bodyText: "Acknowledged Failed!",
        onConfirm: () => setShowMessage(false),
        confirmText: "OK"
      });
      return;
      setShowMessage(true);
    } finally {
      setAlertLoading(false);
    }
  }

  return (
    <Modal
      className="opal-acknowledgement-modal"
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <div>For Acknowledgement</div>
        <TauriImage localImage={"/Images/material-symbols--close.svg"} className="modal-close-icon" color={"#FFFFFF"} onClick={onHide} />
      </Modal.Header>

      <Modal.Body>
        {loading ? (
          <TauriLoader2 width="2.5rem" height="2.5rem" borderwidth="0.35rem" color="#1D5D9B" />
        ) : (
          <Accordion defaultActiveKey="0" alwaysOpen>
            {data.map((transaction, index) => (
              <Accordion.Item eventKey={String(index)} key={transaction.ID}>
                <Accordion.Header className="p-0 mb-2">
                  <div className="header-container d-flex justify-content-between w-100">

                    <div className="header-left">
                      <span className="header-title">
                        {transaction?.TransactionNumber}
                      </span>
                    </div>

                    <div className="d-flex align-items-center justify-content-end header-filter">
                      <Button
                        className="btn d-flex align-items-center justify-content-center m-0 btn-ack"
                        size="sm"
                        disabled={loading}
                        onClick={(e) => {
                          e.stopPropagation()
                          setAlertMessage({
                            title: "Confirm",
                            bodyText: "Are you sure you want to acknowledge this transaction?",
                            onConfirm: () => {
                              AcknowledgeStocks(transaction?.ID);
                            },
                            confirmText: "Yes",
                            cancelText: "No",
                            type: "confirm"
                          });

                          setShowMessage(true);
                        }}
                      >
                        <TauriImage localImage="/Images/outline-inventory.svg" className="inv-icon-find me-1" color={"#FFF"} />
                        <div>Acknowledge</div>
                      </Button>
                    </div>

                  </div>
                </Accordion.Header>

                <Accordion.Body>
                  <table className="oaim-table">
                    <thead className="oaim-table-header">
                      <tr>
                        <th>Item Code</th>
                        <th>Item Description</th>
                        <th>Stocks</th>
                      </tr>
                    </thead>

                    <tbody className="oaim-table-body">
                      {transaction.Items?.map((item, idx) => (
                        <tr key={idx}>
                          <td>{item?.Item?.Code}</td>
                          <td>{item?.Item?.Description}</td>
                          <td>{item.Stocks}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Accordion.Body>

              </Accordion.Item>
            ))}
          </Accordion>
        )}

      </Modal.Body>

      <Modal.Footer>
        <Button className="button-close" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
      <OpalAlertModal
        show={showMessage}
        onHide={() => setShowMessage(false)}
        title={alertMessage?.title}
        bodyText={alertMessage?.bodyText}
        onConfirm={alertMessage?.onConfirm}
        confirmButtonText={alertMessage?.confirmText}
        cancelButtonText={alertMessage?.cancelText}
        loading={alertLoading}
        modalType={alertMessage?.type ?? "message"}
      />

    </Modal>
  );
};

export default OpalForAcknowledementModal;